export const storeName = 'videoSession'
export const signals = {
  CALLING: 'calling',
  ASKING_FOR_PERMISSION: 'askingForPermission',
  ACCEPTED_PERMISSION: 'acceptedPermission',
  DECLINED_PERMISSION: 'declinedPermission',
  MUTED_AUDIO: 'mutedAudio',
  UNMUTED_AUDIO: 'unmutedAudio',
  APP_BACKGROUNDED: 'appBackgrounded',
  APP_FOREGROUNDED: 'appForegrounded',
  ENDED_CALL: 'endedCall',

  properties: {
    SENDER: 'sender',
    CONNECTION_ID: 'connectionId',
    senderTypes: {
      PATIENT: 'patient',
      CARE_PLATFORM: 'care-platform',
    },
    PERMISSIONS_TYPE: 'permissionType',
    permissionTypes: {
      VIDEO: 'video',
      AUDIO: 'audio',
    },
  },
}

export enum packetLossStatuses {
  WARNING = 'WARNING',
  CRITICAL = 'CRITICAL',
  OKAY = 'OKAY',
}

export enum packetLossThresholds {
  WARNING = 2.5,
  CRITICAL = 5,
}
